import { PublicReportUI } from 'features'

const PublicReportPage = () => {
  return (
    <div>
      <PublicReportUI/>
    </div>
  )
}

export { PublicReportPage }